module.exports = __webpack_public_path__ + "img/nav.6a8b7ae0.svg";